// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__wVE0g","content":"GlobalSearch_content__2GsAq"};